<template>
  <b-card class="text-secondary">
    <img v-if="passImage" :src="passImage" class="mb-4 rounded">

    <div v-if="to.name" class="mb-1">
      <strong>{{ to.name }},</strong>
    </div>
    {{ message }}
    <div v-if="from.name" class="mt-3">
      <strong>{{ from.name }}</strong>
    </div>
    <hr>
    <h3 class="font-semibold text-xl mt-6 mb-6">
      {{ pass.name }}
    </h3>
    <h6 class="text-xs font-weight-light mb-2">
      {{ $site.location.title }}
    </h6>

    <small v-if="deliveryDate" class="text-xs">
      {{ $t('general.deliveredOn') }}: {{ $format.date(deliveryDate.getTime() / 1000, 'local') }}
    </small>
  </b-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: 'Find Customer'
    }
  },
  computed: {
    pass () {
      return this.$store.getters['gift/pass']
    },
    to () {
      return this.$store.getters['gift/to']
    },
    from () {
      return this.$store.getters['gift/from']
    },
    message () {
      return this.$store.getters['gift/message']
    },
    deliveryDate () {
      return this.$store.getters['gift/deliveryDate']
    },
    passImage () {
      if (this.pass.images) {
        return this.pass.images.large
      } else if (this.$site.images.pass) {
        return this.$site.images.pass.large
      }
      return null
    }
  }
}
</script>
